import PatientNotesList from './PatientNotesList';

export default PatientNotesList;
